import { Transition } from 'semantic-ui-react';

// STYLES
import styles from './TopBanner.styles.less';

const TopBanner = ({ children, visible = false }) => (
  <Transition visible={visible} animation="slide down" duration={500}>
    <div className={`ui message warning ${styles['top-banner']}`}>{children}</div>
  </Transition>
);

export default TopBanner;
